/* ==========================================================================
   FC – Puzzle Gate v2.7 (lean)
   - Idempotent init guard
   - Guide + pieces preload
   - Drag/snap to true centers
   - Emits: fc:puzzle:ready, fc:puzzle:solved
   - Spinner text flicker + 3-phase unlock FX (video or CSS)
   - Universal fade on solve (even if FX fails)
   ========================================================================== */
(() => {
/* ============================ 1) INIT GUARD ============================== */
if (window.__FCPUZZLE_ACTIVE__) { console.warn('[FC] already initialized. Skipping.'); return; }
window.__FCPUZZLE_ACTIVE__ = true;

/* ============================ 2) MINIMAL CSS INJECTION =================== */
(function ensureCSS(){
  if (document.getElementById('fc-puzzle-css')) return;
  const el = document.createElement('style');
  el.id = 'fc-puzzle-css';
  el.textContent = `
    #fc-puzzle.fc-peak-hide,
    #fc-puzzle-board.fc-peak-hide,
    #fc-puzzle-guide.fc-peak-hide { opacity:0 !important; transition:opacity .18s ease !important; }
    .fc-peak-hide-piece { opacity:0 !important; transition:opacity .18s ease !important; }
  `;
  document.head.appendChild(el);
})();

/* ===== Universal fade of puzzle/guide on solve (even if FX doesn’t run) == */
(function(){
  function fadePuzzle(){
    ['fc-puzzle','fc-puzzle-board','fc-puzzle-guide']
      .forEach(id => document.getElementById(id)?.classList.add('fc-peak-hide'));
    document.querySelectorAll('.fc-piece').forEach(n=>n.classList.add('fc-peak-hide-piece'));
  }
  window.addEventListener('fc:puzzle:solved', fadePuzzle, { once:true });
})();

/* ============================ 3) SVG FILTERS ============================= */
(function ensureSVGDefs(){
  document.getElementById('fc-outline-defs')?.remove();
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.id = 'fc-outline-defs';
  svg.setAttribute('width','0'); svg.setAttribute('height','0');
  svg.style.position = 'absolute'; svg.style.left = '-9999px'; svg.style.top = '-9999px';
  svg.innerHTML = `
    <defs>
      <filter id="fc-outline-only" color-interpolation-filters="sRGB" x="-60%" y="-60%" width="220%" height="220%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="D"/>
        <feComposite  in="D" in2="SourceAlpha" operator="out" result="RING"/>
        <feFlood flood-color="#FFFFFF" flood-opacity="0.44" result="COL"/>
        <feComposite in="COL" in2="RING" operator="in" result="STROKE"/>
        <feMerge><feMergeNode in="STROKE"/></feMerge>
      </filter>
      <filter id="fc-outline-glow" color-interpolation-filters="sRGB" x="-80%" y="-80%" width="260%" height="260%">
        <feMorphology in="SourceAlpha" operator="dilate" radius="1" result="D"/>
        <feComposite  in="D" in2="SourceAlpha" operator="out" result="RING"/>
        <feFlood flood-color="#FFFFFF" flood-opacity="0.44" result="COLSTROKE"/>
        <feComposite in="COLSTROKE" in2="RING" operator="in" result="STROKE"/>
        <feGaussianBlur in="RING" stdDeviation="0" result="GLOWBLUR"/>
        <feFlood flood-color="#FFC527" flood-opacity="0.00" result="COLGLOW"/>
        <feComposite in="COLGLOW" in2="GLOWBLUR" operator="in" result="GLOW"/>
        <feMerge><feMergeNode in="GLOW"/><feMergeNode in="STROKE"/></feMerge>
      </filter>
    </defs>`;
  (document.body || document.documentElement).appendChild(svg);
})();

/* ============================ 4) CONFIG ================================= */
const ASSET_BASE = String((window.FC_ASSET_BASE || '')).replace(/\/+$/,'') + '/';
const BASE_AR = { w:1600, h:1100 };
const PIECES = [
  { id:"top_left2",     file:"top_left2.png",     xP:0.284542, yP:0.387343, s:2.495546 },
  { id:"top_middle2",   file:"top_middle2.png",   xP:0.496837, yP:0.387508, s:2.492159 },
  { id:"top_right2",    file:"top_right2.png",    xP:0.710552, yP:0.387868, s:2.475244 },
  { id:"left_corner2",  file:"left_corner2.png",  xP:0.091145, yP:0.387127, s:2.474605 },
  { id:"hook2",         file:"hook2.png",         xP:0.498898, yP:0.124017, s:2.486269 },
  { id:"right_corner2", file:"right_corner2.png", xP:0.903835, yP:0.387670, s:2.489379 },
  { id:"bottom_left2",  file:"bottom_left2.png",  xP:0.336659, yP:0.678678, s:2.494202 },
  { id:"bottom2",       file:"bottom2.png",       xP:0.496921, yP:0.913803, s:2.486005 },
  { id:"bottom_right2", file:"bottom_right2.png", xP:0.654140, yP:0.677797, s:2.489537 }
];

/* ============================ 5) STATE/HELPERS =========================== */
const board = document.getElementById('fc-puzzle-board');
if (!board) { console.error('[FC] #fc-puzzle-board not found.'); return; }
if (board.dataset.fcInit === '1') {
  document.querySelectorAll('#fc-puzzle-board .fc-slot, #fc-puzzle-board .fc-piece, #fc-puzzle-guide').forEach(n=>n.remove());
}

board.dataset.fcInit = '1';

// Detect assembly mode once and expose global silence flag
(function(){
  try {
    const qs = new URLSearchParams(location.search);
    window.FC_ASSEMBLY_SILENT = (qs.get('assembly') === '1' || qs.get('assembly') === 'true');
  } catch(_) {
    window.FC_ASSEMBLY_SILENT = false;
  }
})();

let guideW = 0, guideH = 0, scale = 1;
let lockedCount = 0, DEBUG = false, BOOTED = false, GUIDE_LOADED = false;
let zCounter = 500;

const slots = new Map();     // id -> slot div
const piecesMap = new Map(); // id -> piece img
const naturals = new Map();  // id -> [nw, nh]

const log  = (...a)=>{ if (DEBUG) console.log('[FC]', ...a); };
const warn = (...a)=>console.warn('[FC]', ...a);

const place=(el,x,y)=>{ el.style.left = x+'px'; el.style.top = y+'px'; };
const boardRect=()=>board.getBoundingClientRect();
const toBoardXY=(clientX,clientY)=>{ const br=boardRect(); return [clientX - br.left, clientY - br.top]; };
const getSnapPx=()=>{ const BW=board.clientWidth; return Math.max(12, Math.round(BW*0.07)); };

function applyZ(el){
  if (!el) return;
  if (el.classList.contains('fc-piece--dragging')) el.style.zIndex = 9999;
  else if (el.classList.contains('fc-piece--locked')) el.style.zIndex = 300;
  else el.style.zIndex = Math.max(400, ++zCounter);
}

function sizeBoard(arW, arH){
  const vh = Math.max(1, window.innerHeight);
  const vw = Math.max(1, window.innerWidth);
  const ar = arW / arH;
  const targetH = Math.min(vh * 0.45, (vw / ar) * 0.92);
  const targetW = Math.max(1, Math.round(targetH * ar));
  board.style.height = targetH + 'px';
  board.style.width  = targetW + 'px';
  board.style.aspectRatio = `${arW} / ${arH}`;
  scale = targetW / arW;
  log('sizeBoard', {targetW, targetH, arW, arH, scale:+scale.toFixed(4)});
}

/* Steps the pyramid glow by 10px per locked piece */
function applyGlowStrength(){
  const locked = Math.max(0, lockedCount|0);
  const radius = Math.max(0, (locked - 1) * 10);   // px
  const glowImg = document.querySelector('#fc-puzzle-guide .guide-glow');
  if (glowImg){ glowImg.style.filter = `drop-shadow(0 0 ${radius}px gold)`; }
  const strokeImg = document.querySelector('#fc-puzzle-guide .guide-stroke');
  if (strokeImg && !strokeImg.dataset.dsApplied){
    strokeImg.style.filter = `url(#fc-outline-only) drop-shadow(0 0 6px rgba(0,0,0,.9))`;
    strokeImg.dataset.dsApplied = '1';
  }
  if (DEBUG) console.log('[FC] glow step', { locked, radiusPx: radius });
}

/* ============================ 6) GUIDE LOAD ============================== */
const guideWrap = document.createElement('div');
guideWrap.id = 'fc-puzzle-guide';
guideWrap.innerHTML = `
  <img class="guide-stroke" alt="" src="${ASSET_BASE}p0_2.png" aria-hidden="true">
  <div class="guideWrapper" style="filter:blur(6px);">
    <img class="guide-blur" alt="" src="${ASSET_BASE}p0_2.png">
    <img class="guide-glow" alt="" src="${ASSET_BASE}p0_2.png" aria-hidden="true">
  </div>
`;
board.prepend(guideWrap);
const guideImg = guideWrap.querySelector('img');

function bootOnce(){ if (BOOTED) return; BOOTED = true; preloadPieces(); }

guideImg.addEventListener('load', () => {
  GUIDE_LOADED = true;
  guideW = guideImg.naturalWidth || BASE_AR.w;
  guideH = guideImg.naturalHeight || BASE_AR.h;
  sizeBoard(guideW, guideH);
  if (BOOTED) { layoutAll(false); } else { bootOnce(); }
}, { once:true });

setTimeout(() => {
  if (GUIDE_LOADED) return;
  warn('guide timeout, using fallback aspect');
  guideW = BASE_AR.w; guideH = BASE_AR.h;
  sizeBoard(guideW, guideH);
  bootOnce();
}, 1800);

/* ============================ 7) PRELOAD/BUILD =========================== */
function preloadPieces(){
  Promise.all(PIECES.map(p => new Promise((resolve,reject) => {
    const img = new Image();
    img.onload  = () => resolve({ id:p.id, file:p.file, nw:img.naturalWidth, nh:img.naturalHeight });
    img.onerror = () => reject(new Error('Failed to load '+p.file));
    img.crossOrigin = 'anonymous';
    img.src = ASSET_BASE + p.file;
  }))).then(list => {
    const BW = board.clientWidth, BH = board.clientHeight;

    PIECES.forEach(p => {
      const slot = document.createElement('div');
      slot.className = 'fc-slot'; slot.dataset.id = p.id;
      place(slot, p.xP * BW, p.yP * BH);
      board.appendChild(slot);
      slots.set(p.id, slot);
    });

    list.forEach(({id, file, nw, nh}) => {
      naturals.set(id, [nw, nh]);
      const el = document.createElement('img');
      el.className = 'fc-piece';
      el.draggable = false; el.alt = id; el.dataset.id = id;
      el.src = ASSET_BASE + file;
      board.appendChild(el);
      piecesMap.set(id, el);
      applyZ(el);
    });

    layoutAll(true);
    applyGlowStrength();
    attachDragHandlers();
    window.dispatchEvent(new Event('fc:puzzle:ready'));
    log('ready', infoObject());
  }).catch(err => console.error('[FC] preload error:', err));
}

/* ============================ 8) LAYOUT ================================= */
function layoutAll(scatter=false){
  const BW = board.clientWidth, BH = board.clientHeight;
  if (BW < 10 || BH < 10){ warn('board too small', {BW, BH}); }
  scale = (guideW>0) ? (BW / guideW) : scale;

  PIECES.forEach((p, i) => {
    const slot = slots.get(p.id);
    const el   = piecesMap.get(p.id);
    if (!slot || !el) return;

    place(slot, p.xP * BW, p.yP * BH);

    const [nw, nh] = naturals.get(p.id) || [0,0];
    const w = (nw * scale * (p.s || 1));
    const h = (nh * scale * (p.s || 1));
    el.style.width  = w + 'px';
    el.style.height = h + 'px';

    // keep entire piece inside the board when scattering
    if (scatter && !el.classList.contains('fc-piece--locked') && !el.style.left){
      const pad = Math.max(24, Math.min(BW, BH) * 0.06);
      const hw = w * 0.5, hh = h * 0.5;
      const rx = (min, max) => min + Math.random() * (max - min);
      const safeXMin = hw + pad, safeXMax = Math.max(safeXMin, BW - hw - pad);
      const safeYMin = hh + pad, safeYMax = Math.max(safeYMin, BH - hh - pad);
      const side = i % 4;
      if (side === 0) place(el, rx(safeXMin, safeXMax), safeYMin);         // top band
      if (side === 1) place(el, rx(safeXMin, safeXMax), safeYMax);         // bottom band
      if (side === 2) place(el, safeXMin, rx(safeYMin, safeYMax));         // left band
      if (side === 3) place(el, safeXMax, rx(safeYMin, safeYMax));         // right band
    } else if (el.classList.contains('fc-piece--locked')){
      place(el, parseFloat(slot.style.left)||0, parseFloat(slot.style.top)||0);
    }
  });
  if (DEBUG) log('layout', {BW, BH, scale:+scale.toFixed(4), snapPx:getSnapPx()});
}

/* ============================ 9) DRAG & SNAP ============================= */
function attachDragHandlers(){
  let active = null;

  function onPointerDown(e){
    const el = e.currentTarget;
    if (el.classList.contains('fc-piece--locked')) return;

    const br = boardRect();
    const r  = el.getBoundingClientRect();
    const centerX = (r.left - br.left) + r.width/2;
    const centerY = (r.top  - br.top ) + r.height/2;
    const [px, py] = toBoardXY(e.clientX, e.clientY);

    active = { el, id: el.dataset.id, offX: centerX - px, offY: centerY - py, startX: centerX, startY: centerY };
    el.setPointerCapture?.(e.pointerId);
    el.addEventListener('pointermove', onPointerMove, { passive:false });
    el.addEventListener('pointerup',   onPointerUp,   { passive:false, once:true });

    el.classList.add('fc-piece--dragging');
    el.style.zIndex = ++zCounter;

    e.preventDefault();
    if (!window.FC_ASSEMBLY_SILENT) { FC_Audio?.play('grab', { volume: 0.6 }); }
  }

  function onPointerMove(e){
    if (!active) return;
    const [px, py] = toBoardXY(e.clientX, e.clientY);
    place(active.el, px + active.offX, py + active.offY);
    e.preventDefault();
  }

  function onPointerUp(e){
    if (!active) return;
    const id   = active.id;
    const el   = active.el;
    const slot = slots.get(id);
    const br   = boardRect();
    const er   = el.getBoundingClientRect();

    const currC = { x: (er.left - br.left) + er.width/2, y: (er.top - br.top) + er.height/2 };
    const slotC = { x: parseFloat(slot.style.left)||0,   y: parseFloat(slot.style.top)||0 };
    const dx = currC.x - slotC.x, dy = currC.y - slotC.y;
    const dist = Math.hypot(dx, dy);

    const SNAP_PX = getSnapPx();

    if (dist <= SNAP_PX){
      // success: animate into slot, then lock + sound (sound gated when in assembly mode)
      el.style.transition = 'left .22s ease, top .22s ease';
      place(el, slotC.x, slotC.y);
      setTimeout(() => {
        el.style.transition = '';
        el.classList.add('fc-piece--locked');
        lockedCount++;
        applyGlowStrength();
        if (lockedCount === PIECES.length){
          window.dispatchEvent(new Event('fc:puzzle:solved'));
        }
        if (!window.FC_ASSEMBLY_SILENT) { FC_Audio?.play('place', { volume: 0.8 }); }
      }, 230);
    } else {
      // miss: no snap-back; optional gentle fail sound only
      if (!window.FC_ASSEMBLY_SILENT) { FC_Audio?.play('fail', { volume: 0.4 }); }
    }

    el.classList.remove('fc-piece--dragging');
    applyZ(el);

    active = null;
    e.currentTarget.removeEventListener('pointermove', onPointerMove);
  }

  piecesMap.forEach(el => el.addEventListener('pointerdown', onPointerDown, { passive:false }));

  let to=null;
  window.addEventListener('resize', () => {
    clearTimeout(to);
    to = setTimeout(() => { layoutAll(false); applyGlowStrength(); }, 120);
  });

  const mo = new MutationObserver(muts => {
    for (const m of muts){
      if (m.type === 'attributes' && m.attributeName === 'class' && m.target.matches('.fc-piece')) {
        applyZ(m.target);
      }
      if (m.type === 'childList') {
        m.addedNodes.forEach(n => n.nodeType === 1 && n.matches?.('.fc-piece') && applyZ(n));
      }
    }
  });
  mo.observe(board, {subtree:true, childList:true, attributes:true, attributeFilter:['class']});
}

/* ============================ 10) SPINNER & FX =========================== */
(() => {
  const FX = Object.assign({
    spinnerScramble: true,
    spinnerLoopEveryMs: 3200,
    mode: (window.FC_SOLVE && window.FC_SOLVE.video) ? 'video' : 'css',
    video: null,
    pyramid: null,
    phaseMs: { p1: 420, p2: 560, p3: 540 }
  }, window.FC_SOLVE || {});

  /* --- spinner scramble --- */
  if (FX.spinnerScramble) {
    const spinner = document.getElementById('fc-gate-spinner');
    if (spinner) {
      const txt = spinner.textContent.trim();
      const randDigit = () => String((Math.random()*10)|0);
      const scrambleTo = (el, finalText, duration) => {
        const chars = finalText.split(''); const n = chars.length;
        const start = performance.now();
        const frame = now => {
          const t = Math.min(1, (now-start)/duration);
          el.textContent = chars.map((ch,i)=>{
            if (ch === ' ') return ' ';
            const lockAt = (i+1)/n;
            if (t < lockAt*0.85) return randDigit();
            if (t < lockAt) return Math.random()<0.5 ? randDigit() : ch;
            return ch;
          }).join('');
          if (t < 1) requestAnimationFrame(frame); else el.textContent = finalText;
        };
        requestAnimationFrame(frame);
      };
      const doScramble = () => scrambleTo(spinner, txt, 900);
      doScramble();
      const rep = setInterval(doScramble, FX.spinnerLoopEveryMs);
      window.addEventListener('fc:puzzle:ready', ()=>clearInterval(rep), { once:true });
    }
  }

  /* --- helpers --- */
  function hideGateNow(){
    ['fc-puzzle','fc-puzzle-board','fc-puzzle-guide'].forEach(id=>{
      const n=document.getElementById(id);
      if (n && !n.classList.contains('fc-peak-hide')) n.classList.add('fc-peak-hide');
    });
    document.querySelectorAll('.fc-piece').forEach(n=>n.classList.add('fc-peak-hide-piece'));
  }
  const currOrientation = () => matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';

  function pickSrcSet(src){
    if (!src) return [];
    if (typeof src === 'string' || Array.isArray(src)) return Array.isArray(src) ? src : [src];
    const chosen = (currOrientation()==='portrait')
      ? (src.portrait || src.default || src.landscape)
      : (src.landscape || src.default || src.portrait);
    return Array.isArray(chosen) ? chosen : [chosen];
  }

  function buildVideoEl(urls){
    const v = document.createElement('video');
    v.className = 'fx-video';
    v.playsInline = true; v.setAttribute('playsinline','');
    v.muted = true;       v.setAttribute('muted','');
    v.preload = 'auto';   v.autoplay = true;
    urls.filter(Boolean).forEach(u=>{
      const s = document.createElement('source');
      s.src = u;
      const ext = (u.split('?')[0].split('.').pop()||'').toLowerCase();
      s.type = ext==='webm' ? 'video/webm' : ext==='mp4' ? 'video/mp4' : '';
      v.appendChild(s);
    });
    const tryPlay = () => { try { v.currentTime = 0; v.play(); } catch {} };
    v.addEventListener('canplay', tryPlay, { once:true });
    document.addEventListener('touchstart', tryPlay, { once:true, passive:true });
    return v;
  }

  /* --- NEW: preload video only AFTER the puzzle is ready (bandwidth-safe) --- */
let PRE = { v:null, ori:null };

(function setupPreloadAfterReady(){
  if (!window.FC_SOLVE || !window.FC_SOLVE.video) return;

  const currOrientation = () => matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
  function pickSrcSet(src){
    if (!src) return [];
    if (typeof src === 'string' || Array.isArray(src)) return Array.isArray(src) ? src : [src];
    const chosen = (currOrientation()==='portrait')
      ? (src.portrait || src.default || src.landscape)
      : (src.landscape || src.default || src.portrait);
    return Array.isArray(chosen) ? chosen : [chosen];
  }

  function launch(){
    const ori  = currOrientation();
    const urls = pickSrcSet(window.FC_SOLVE.video);

    // Hint the browser, but with low priority
    try {
      urls.forEach(u=>{
        const l = document.createElement('link');
        l.rel = 'preload';
        l.as  = 'video';
        l.href = u;
        // modern Chromium: prefer low fetch priority so puzzle wins
        l.fetchPriority = 'low';
        document.head.appendChild(l);
      });
    } catch {}

    // Build hidden <video>, start with metadata-only to keep it light
    const v = document.createElement('video');
    v.playsInline = true; v.muted = true; v.preload = 'metadata';
    urls.forEach(u=>{
      const s = document.createElement('source');
      s.src = u;
      const ext = (u.split('?')[0].split('.').pop()||'').toLowerCase();
      s.type = ext==='webm' ? 'video/webm' : ext==='mp4' ? 'video/mp4' : '';
      v.appendChild(s);
    });
    Object.assign(v.style, { position:'absolute', left:'-9999px', top:'-9999px', width:'1px', height:'1px' });
    document.body.appendChild(v);

    // On first user gesture, upgrade to full preload + decoder warm-up
    const prime = () => {
      v.preload = 'auto';
      try { v.load(); } catch {}
      v.play().then(()=>{ v.pause(); v.currentTime = 0; }).catch(()=>{});
      cleanup();
    };
    const cleanup = () => ['pointerdown','touchstart','keydown'].forEach(t=>window.removeEventListener(t, prime));
    ['pointerdown','touchstart','keydown'].forEach(t=>window.addEventListener(t, prime, { once:true, passive:true }));

    PRE = { v, ori };
  }

  // Wait until the puzzle has fully built and fired its ready event
  window.addEventListener('fc:puzzle:ready', () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(launch, { timeout: 1500 }); // run in idle time
    } else {
      setTimeout(launch, 0);                           // next tick
    }
  }, { once:true });

  // In your playUnlockFX(), keep reusing PRE.v if orientation matches.
})();

  function playUnlockFX(){
    document.getElementById('fc-flash')?.remove();
    const root = document.createElement('div');
    root.id = 'fc-flash'; root.setAttribute('aria-hidden','true');

    if (FX.mode === 'video' && FX.video){
      const nowOri = currOrientation();
      let v;

      if (PRE.v && PRE.ori === nowOri) {
        v = PRE.v;
        v.className = 'fx-video';
        v.removeAttribute('style');   // unhide (remove -9999px)
        // make sure it actually plays
        v.autoplay = true;
        v.muted = true;
        v.playsInline = true;

        const kick = () => { try { v.currentTime = 0; v.play(); } catch {} };
        if (v.readyState >= 2) {
          kick();                    // already have enough to start
        } else {
          v.addEventListener('canplay', kick, { once: true });
          try { v.load(); } catch {}
        }
      } else {
        const urls = pickSrcSet(FX.video);
        v = buildVideoEl(urls);      // this path already autoplays via canplay
      }
      root.appendChild(v);

      // reuse preloaded video if orientation still matches; else build fresh
      if (PRE.v && PRE.ori === nowOri) {
        v = PRE.v;
        v.className = 'fx-video';
        v.style.cssText = ''; // unhide
      } else {
        const urls = pickSrcSet(FX.video);
        v = buildVideoEl(urls);
      }

      root.appendChild(v);
      const glow = document.createElement('div'); glow.className='fx-glow'; root.appendChild(glow);

      const HIDE_AT_MS = Number((window.FC_SOLVE && window.FC_SOLVE.hideAtMs) ?? 844.879);
      let didHide = false;
      const hideIfDue = (tMs) => { if (!didHide && tMs >= HIDE_AT_MS) { didHide = true; hideGateNow(); } };

      if (typeof v.requestVideoFrameCallback === 'function') {
        const step = (_now, meta) => { if (didHide) return; hideIfDue((meta?.mediaTime||0)*1000); if (!didHide) v.requestVideoFrameCallback(step); };
        v.requestVideoFrameCallback(step);
      } else {
        let rafId = 0;
        const rafStep = () => { if (didHide) return; hideIfDue((v.currentTime||0)*1000); if (!didHide) rafId = requestAnimationFrame(rafStep); };
        v.addEventListener('timeupdate', () => hideIfDue((v.currentTime||0)*1000));
        rafId = requestAnimationFrame(rafStep);
        const stop = () => { if (rafId) cancelAnimationFrame(rafId); };
        v.addEventListener('ended', stop, { once:true });
        v.addEventListener('pause', stop, { once:true });
      }
    } else {
      const py = FX.pyramid || (document.querySelector('#fc-puzzle-guide img')?.src || '');
      root.innerHTML = `
        ${py ? `<img class="fx-pyramid" src="${py}" alt="">` : ''}
        <div class="fx-glow"></div>
        <div class="streak s1"></div><div class="streak s2"></div>
        <div class="streak s3"></div><div class="streak s4"></div>
      `;
    }
    document.body.appendChild(root);

    const t1 = Number(FX.phaseMs?.p1) || 0;
    const t2 = Number(FX.phaseMs?.p2) || 0;
    const t3 = Number(FX.phaseMs?.p3) || 0;

    root.classList.add('phase1');
    setTimeout(() => { root.classList.add('phase2'); window.dispatchEvent(new Event('fc:unlock:now')); }, t1);
    setTimeout(() => { root.classList.add('phase3'); }, t1 + t2);
    setTimeout(() => { window.dispatchEvent(new Event('fc:unlock:complete')); root.remove(); }, t1 + t2 + t3 + 50);
  }

  window.FC_PlayUnlockFX = playUnlockFX;
  window.addEventListener('fc:puzzle:solved', () => { FC_Audio?.play('solved', { volume: 0.9 }); });
})();
/* ============================ 10.5) TAUNT HUD ============================ */
(() => {
  const el = document.getElementById('fc-taunt');
  const textEl = el?.querySelector('.fc-taunt-text');
  if (!el || !textEl) return;

  function scrambleTo(el, finalText, duration){
    const chars = finalText.split(''); const n = chars.length;
    const start = performance.now();
    const randDigit = () => String((Math.random()*10)|0);
    function frame(now){
      const t = Math.min(1, (now-start)/duration);
      el.textContent = chars.map((ch,i)=>{
        if (ch === ' ') return ' ';
        const lockAt = (i+1)/n;
        if (t < lockAt*0.85) return randDigit();
        if (t < lockAt) return Math.random()<0.5 ? randDigit() : ch;
        return ch;
      }).join('');
      if (t < 1) requestAnimationFrame(frame); else el.textContent = finalText;
    }
    requestAnimationFrame(frame);
  }

  window.addEventListener('fc:puzzle:ready', () => {
    el.style.display = 'block';
    requestAnimationFrame(() => { el.style.opacity = '1'; });
    const finalText = textEl.dataset.text || textEl.textContent.trim();
    const dur = Number(window.FC_SOLVE?.scramble_ms) || 900;
    scrambleTo(textEl, finalText, dur);
  }, { once: true });

  window.addEventListener('fc:unlock:now', () => { el.style.opacity = '0'; }, { once: true });
})();

/* ============================ 11) DEBUG SURFACE ========================== */
function infoObject(){
  return {
    guideNatural: `${guideW}×${guideH}`,
    board: `${board.clientWidth}×${board.clientHeight}`,
    scale: +scale.toFixed(4),
    snapPx: getSnapPx(),
    locked: `${lockedCount}/${PIECES.length}`,
    assetBase: ASSET_BASE
  };
}

window.FCPuzzle = {
  debug(on=true){ DEBUG=!!on; console.log('[FC] debug=', DEBUG); },
  showSlots(on=true){ board.classList.toggle('fc-debug-slots', !!on); },
  scramble(){
    lockedCount=0;
    piecesMap.forEach(el => el.classList.remove('fc-piece--locked'));
    piecesMap.forEach(el=>{ el.style.left=''; el.style.top=''; });
    layoutAll(true);
  },
  refresh(){ layoutAll(false); },
  info(){ console.table(infoObject()); },
  placeAllStrict(){
    PIECES.forEach(p=>{
      const slot = slots.get(p.id), el = piecesMap.get(p.id);
      if(!slot||!el) return;
      place(el, parseFloat(slot.style.left)||0, parseFloat(slot.style.top)||0);
    });
    console.log('[FC] placeAllStrict done');
  },
  report(){
    const out = {};
    const br = boardRect();
    PIECES.forEach(p=>{
      const el = piecesMap.get(p.id), slot = slots.get(p.id); if(!el||!slot) return;
      const er = el.getBoundingClientRect();
      const currC = {x:(er.left-br.left)+er.width/2, y:(er.top-br.top)+er.height/2};
      const slotC = {x:parseFloat(slot.style.left)||0, y:parseFloat(slot.style.top)||0};
      out[p.id] = {
        pieceX:Math.round(currC.x), pieceY:Math.round(currC.y),
        slotX:Math.round(slotC.x),  slotY:Math.round(slotC.y),
        dist: Math.round(Math.hypot(currC.x-slotC.x, currC.y-slotC.y)),
        locked: el.classList.contains('fc-piece--locked')
      };
    });
    console.table(out); return out;
  }
};
})(); // <— closes the top-level IIFE